module.exports = __webpack_public_path__ + "static/media/loading-spinner-switch-2x.ba3df73c.gif";